import { Quote } from "lucide-react";

const STORIES = [
  {
    quote:
      "Emporia turned our first China shipment into a system. We source more, pay less, and never chase paperwork.",
    name: "Procurement Team",
    role: "Baybee · Kids & Baby brand",
  },
  {
    quote:
      "They walked the Yiwu market with us for days, negotiated in Mandarin, and shipped multiple containers door-to-door. Flawless.",
    name: "Sourcing Lead",
    role: "Style Union · Lifestyle retail",
  },
  {
    quote:
      "Customs used to take a week — now we unload in 48 hours. A real partner, not a vendor.",
    name: "Operations",
    role: "Dispomate · Medical disposables",
  },
];

const LOGOS = [
  "BAYBEE",
  "STYLE UNION",
  "DISPOMATE",
  "ORTHODENT",
  "PREVALENT",
  "KIDZON",
  "PRIMUS B SCHOOL",
  "HISTORICAL WALES",
];

export default function ClientStories() {
  return (
    <section
      id="stories"
      data-testid="stories-section"
      className="relative bg-ink text-white py-14 md:py-28 overflow-hidden"
    >
      <div className="absolute inset-0 grain opacity-30" aria-hidden />
      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8 items-end mb-14 md:mb-20">
          <div className="md:col-span-8">
            <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-signal mb-5">
              04 — Client stories
            </p>
            <h2 className="font-heading font-black tracking-[-0.03em] leading-[0.95] text-4xl md:text-5xl lg:text-6xl">
              Shipped, cleared,<br />
              <span className="text-stroke-light">on record.</span>
            </h2>
          </div>
          <p className="md:col-span-4 text-white/70 text-base leading-relaxed">
            A small sample from buyers, brands and distributors working with us
            across four continents.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {STORIES.map((s, i) => (
            <article
              key={i}
              data-testid={`story-card-${i}`}
              className="group relative bg-ink-800/40 border border-white/10 p-6 md:p-10 hover:border-signal/70 hover:-translate-y-1 transition-all duration-300"
            >
              <Quote className="w-7 h-7 md:w-8 md:h-8 text-signal mb-4 md:mb-6" strokeWidth={1.4} />
              <p className="font-heading font-medium text-white text-lg md:text-[22px] leading-[1.35] tracking-tight">
                &ldquo;{s.quote}&rdquo;
              </p>
              <div className="mt-6 md:mt-10 pt-4 md:pt-6 border-t border-white/10">
                <div className="font-mono text-[11px] uppercase tracking-[0.22em] text-white">
                  {s.name}
                </div>
                <div className="mt-1 text-white/55 text-sm">{s.role}</div>
              </div>
            </article>
          ))}
        </div>

        {/* Client logo strip */}
        <div className="mt-12 md:mt-24 border-t border-white/10 pt-8 md:pt-10">
          <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-white/50 mb-6 md:mb-8">
            Trusted by
          </p>
          <div className="flex flex-wrap items-center gap-x-6 md:gap-x-12 gap-y-4 md:gap-y-6">
            {LOGOS.map((l) => (
              <span
                key={l}
                className="font-heading font-black text-white/30 hover:text-white transition-colors text-sm md:text-xl tracking-[0.18em] md:tracking-[0.2em]"
              >
                {l}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
